import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login/Login";
import CreateNew from "./pages/Home/CreateNew";
import Home from "./pages/Home/Home";
import ViewStore from "./pages/Home/ViewStore";
import PrivateRoute from "./components/PrivateRoute";
import RequestManagement from "./pages/RequestManagement/RequestManagement";
import RequestManagementView from "./pages/RequestManagement/RequestManagementView";
import UserManagement from "./pages/UserManagement/UserManagement";
import UserManagementCreate from "./pages/UserManagement/UserManagementCreate";
import UserManagementView from "./pages/UserManagement/UserManagementView";
import MappingManagement from "./pages/MappingManagement/MappingManagement";
import AddNewMapping from "./pages/MappingManagement/AddNewMapping";
import EditMapping from "./pages/MappingManagement/EditMapping";
import { isTokenExpired } from "./utils/helpers";
import PulloutLetterNames from "./pages/PulloutLetterNames/PulloutLetterNames";
import Discounts from "./pages/Discounts/Discount";
import Reconciliation from "./pages/Reconciliation/Reconciliation";
import localStorageService from "./services/LocalStorageService";
import Replenishment from "./pages/Replenishment/Replenishment";
import ReplenishmentRequest from "./pages/ReplenishmentRequests/ReplenishmentRequest";
import ReplenishmentRequestDetails from "./pages/ReplenishmentRequests/ReplenishmentRequestDetails";
import Promotions from "./pages/Promotions/Promotions";

import BulkUpload from "./pages/BulkUpload/BulkUpload";

function App() {
  const token = localStorageService.getItem("token");
  const role = localStorageService.getItem("role");

  if (!token || isTokenExpired()) {
    localStorageService.clearStorage();
  }
  return (
    <div className="App">
      <Routes>
        <Route
          element={
            token && !isTokenExpired() ? (
              role === "admin" ? (
                <Navigate to="/home" replace />
              ) : (
                <Navigate to="/request-management" replace />
              )
            ) : (
              <Login />
            )
          }
          path="/"
        />
        <Route path="/" element={<PrivateRoute allowedRoles={["admin"]} />}>
          <Route element={<Home />} path="home" />
          <Route element={<CreateNew />} path="create-new/:id" />
          <Route element={<CreateNew />} path="store-reset-password/:id" />
          <Route element={<ViewStore />} path="view-store-details/:id" />

          <Route element={<UserManagement />} path="user-management" />
          <Route
            element={<UserManagementCreate />}
            path="user-management-create"
          />
          <Route
            element={<UserManagementView />}
            path="user-management-view/:id"
          />
          <Route
            element={<UserManagementView />}
            path="user-management-reset-password/:id"
          />

          <Route element={<MappingManagement />} path="mapping-management" />
          <Route element={<AddNewMapping />} path="create-mapping" />
          <Route element={<EditMapping />} path="edit-mapping/:id" />

          <Route element={<EditMapping />} path="edit-mapping/:id" />

          <Route element={<PulloutLetterNames />} path="pullout-letter-names" />
          <Route element={<Reconciliation />} path="reconciliation" />
          <Route element={<Replenishment />} path="replenishment" />
          <Route element={<BulkUpload />} path="bulk-upload" />
          <Route element={<Promotions />} path="promotions" />
          <Route
            path="*"
            element={
              token && !isTokenExpired() ? (
                <Navigate to="/" replace />
              ) : (
                <Login />
              )
            }
          />
        </Route>

        <Route
          path="/"
          element={<PrivateRoute allowedRoles={["supervisor"]} />}
        >
          <Route element={<RequestManagement />} path="request-management" />
          <Route
            element={<RequestManagementView />}
            path="request-management-view/:id"
          />
          <Route
            element={<ReplenishmentRequest />}
            path="replenishment-requests"
          />
          <Route
            element={<ReplenishmentRequestDetails />}
            path="replenishment-requests/:id"
          />
        </Route>
        <Route
          path="/"
          element={<PrivateRoute allowedRoles={["admin", "supervisor"]} />}
        >
          <Route element={<Discounts />} path="discounts" />
          <Route
            path="*"
            element={
              token && !isTokenExpired() ? (
                <Navigate to="/" replace />
              ) : (
                <Login />
              )
            }
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
